'use client';

import { motion } from 'motion/react';

export default function FooterCopyright() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const currentYear = new Date().getFullYear();

  return (
    <div className="relative border-t border-white/10 bg-black">
      <div className="relative px-6 lg:px-12 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 lg:gap-6 items-center">
          {/* Logo y branding - Columna izquierda */}
          <div className="lg:col-span-4">
            <div className="flex items-center space-x-4 mb-3">
              <img
                src={'/logo-negativo.png'}
                alt="Ghost Cvlt"
                className="h-8 w-auto object-contain mx-auto lg:mx-0"
              />
            </div>

            <p className="text-xs font-urbanist font-light text-white/50 leading-relaxed text-center lg:text-left">
              © {currentYear} Ghost Cvlt. Todos los derechos reservados.
            </p>
          </div>

          {/* Información adicional - Columna central */}
          <div className="lg:col-span-4 text-center">
            <p className="text-xs text-center font-urbanist font-light text-white/50">
              Diseñado y desarrollado por Ghost Cvlt
            </p>
          </div>

          {/* Botón volver arriba - Columna derecha */}
          <div className="lg:col-span-4 flex justify-center lg:justify-end mt-6 lg:mt-0">
            <motion.button
              type="button"
              onClick={scrollToTop}
              whileHover={{
                borderColor: 'rgba(255, 255, 255, 0.8)',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
              }}
              whileTap={{
                transition: { duration: 0.1 },
              }}
              transition={{
                type: 'tween',
                duration: 0.2,
                ease: 'easeOut',
              }}
              className="relative overflow-hidden border border-white/30 px-6 py-2 font-urbanist font-light uppercase tracking-wide text-xs text-white transition-all duration-200 hover:text-white group"
            >
              <span className="relative z-10">Volver arriba ↑</span>
              <motion.div
                className="absolute inset-0 bg-gradient-to-r from-white/5 to-white/10"
                initial={{ x: '-100%' }}
                whileHover={{ x: '0%' }}
                transition={{ duration: 0.3, ease: 'easeOut' }}
              />
            </motion.button>
          </div>
        </div>
      </div>
    </div>
  );
}
